<template>
	<ui-modal-template>
		<template v-slot:title>
			<span>{{ __('userLocations') }} bearbeiten</span>
		</template>
		<template v-slot:content>
			<form class="h-full flex flex-col">

				<div class="py-6">

					<span class="px-6 py-2 text-2xl font-medium">{{ __("Stammbetrieb") }}</span>

					<div
						class="p-6 py-3 px-6"
					>
						<div v-if="!main.toggled"
								 class="flex justify-start items-center gap-x-6"
						>
							<span class="text-xl">{{ main.name }}</span>

							<span>
									<ui-button
										class="hover:bg-gray-100 rounded-lg p-2 text-orange-500"
										v-on:click="toggle(main.id)"
										type="blank"
									>
									<ui-icon name="edit-2" class="text-orange h-6 w-6" stroke-width="2" />
								</ui-button>
							</span>

						</div>
						<div v-else>
							<ui-input-group
								class="col-span-8 md:col-span-4 py-3"
								v-model="form.address.name"
								field="address.name"
								label="Bezeichnung"
								:form="form"
								:required="true"
							></ui-input-group>

							<ui-input-group
								v-model="form.address.street"
								class="col-span-8 md:col-span-5"
								field="address.street"
								label="Street + house number"
								:form="form"
								:required="false"
								:autoReplace="false"
							></ui-input-group>

							<crop-location-picker
								class="col-span-8 mt-0 py-3"
								v-model="form.address"
								:form="form"
							>
							</crop-location-picker>
						</div>

					</div>

					<div v-if="sideUserLocations.length >= 1">
						<hr class="h-0.5 bg-gray-200 text-gray-200 my-2" />
						<span class="px-6 py-2 text-2xl font-medium">{{ __("userLocations") }}</span>
					</div>

					<div
						v-for="(userLocation, index) in sideUserLocations"
						:key="userLocation.id"
						class="px-6 py-3"
					>
						<div v-if="!userLocation.toggled"
								 class="flex justify-start items-center gap-x-6"
						>
							<span class="text-xl">{{ userLocation.name }}</span>

							<span class="flex">
								<ui-tooltip class="font-normal" text="Lagerstandort bearbeiten">
									<template v-slot:label>
										<ui-button
											class="ml-auto hover:bg-gray-100 rounded-lg p-2 text-orange-500"
											v-on:click="toggle(userLocation.id)"
											type="blank"
										>
											<ui-icon name="edit-2" class="text-orange h-6 w-6" stroke-width="2" />
										</ui-button>
									</template>
								</ui-tooltip>

								<ui-tooltip class="font-normal" :text="!userLocation.has_sale_intentions ? 'Lagerstandort löschen' : 'Zugehörige Dashboard-Einträge müssen vorher gelöscht werden.'">
									<template v-slot:label>
										<ui-button
											v-on:click="emitDeleteModal(userLocation.id)"
											class="hover:bg-gray-100 rounded-lg p-2 text-gray-300"
											:class="{'text-orange-500': !userLocation.has_sale_intentions }"
											:disabled="userLocation.has_sale_intentions"
											type="blank"
										>
											<ui-icon class="h-6 w-6" name="trash" stroke-width="2.5" />
										</ui-button>
									</template>
								</ui-tooltip>
							</span>
						</div>
						<div v-else>

							<ui-input-group
								class="col-span-8 md:col-span-4 py-3"
								v-model="form.address.name"
								field="address.name"
								label="Bezeichnung"
								:form="form"
								:required="true"
							></ui-input-group>

							<ui-input-group
								v-model="form.address.street"
								class="col-span-8 md:col-span-5"
								field="address.street"
								label="Street + house number"
								:form="form"
								:required="false"
								:autoReplace="false"
							></ui-input-group>

								<crop-location-picker
									class="col-span-8 mt-0 py-3"
									v-model="form.address"
									:form="form"
								>
								</crop-location-picker>
						</div>

					</div>

					<hr class="h-0.5 bg-gray-200 text-gray-200 my-2" />


					<div
						class="px-6 py-3"
					>
						<div v-if="!createIsToggled"
								 class="flex justify-start"
						>
							<ui-button
								class="flex"
								v-on:click="toggle(form.id)"
							>
								<ui-icon name="plus" class="text-white h-6 w-6" stroke-width="2" /> Neuer Standort
							</ui-button>
						</div>
						<div v-else>

							<ui-input-group
								class="col-span-8 md:col-span-4 py-3"
								v-model="form.address.name"
								field="address.name"
								label="Bezeichnung"
								:form="form"
								:required="true"
							></ui-input-group>

							<ui-input-group
								v-model="form.address.street"
								class="col-span-8 md:col-span-5"
								field="address.street"
								label="Street + house number"
								:form="form"
								:required="false"
								:autoReplace="false"
							></ui-input-group>

							<crop-location-picker
								class="col-span-8 mt-0 py-3"
								v-model="form.address"
								:form="form"
							>
							</crop-location-picker>
						</div>
					</div>

				</div>

				<div class="bg-gray-100 p-6">
					<div class="flex justify-end">
						<ui-button
							:disabled="form.processing"
							v-on:click="submitForm()"
							label="Save"
						/>
					</div>
				</div>
			</form>
		</template>
		<!-- devide -->
	</ui-modal-template>
</template>
<script>
import axios from "axios";
import Vue from "vue";
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		userLocations: {
			type: Array,
			required: true,
		},
	},
	computed: {
		main() {
			return this.userLocations.find((item) => item.is_main);
		},
		sideUserLocations() {
			return this.userLocations.filter((item) => !item.is_main);
		}
	},
	data() {
		let quantity = null;
		if(this.saleIntention?.qty__mt) {
			quantity = parseFloat(this.saleIntention.qty__mt);
		}

		if(this.saleIntention?.qty__remaining) {
			quantity = (parseFloat(this.saleIntention.qty__mt) - parseFloat(this.saleIntention?.qty__remaining));
		}

		const formData = {
			address: {}
		};

		return {
			form: Vue.observable(this.$inertia.form(formData)),
			createIsToggled: false,
		};
	},
	methods: {
		toggle(id) {

			// reset
			this.userLocations.forEach((userLocation) => { userLocation.toggled = false; });
			this.createIsToggled = false;

			const location = this.userLocations.find((item) => item.id === id);

			if(id && location) {
				location.toggled = true;

				this.form.address = {
					id: location.id,
					name: location.name,
					street: location.street,
					zip: location.zip,
					city: location.city,
					country: location.country,
				}

			} else {
				this.form.address = {
					id: null,
					name: null,
					street: null,
					zip: this.user.zip,
					city: this.user.city,
					country: this.user.country,
				};
				this.createIsToggled = true;
			}
		},
		async submitForm() {

      if(!this.form.address.id && !this.createIsToggled) {
        this.$bus.$emit("modal:close");
        return;
      }

			const params = {};
			if (this.form.address.id) {
				params["id"] = this.form.address.id;
			}

			let promise = new Promise((resolve, reject) => {
				const response = axios.post(
					this.$route("user_locations.store", params),
					this.form
				);

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {

			this.$toast.success(__("Lagerstandort wurde gespeichert."));

			this.$bus.$emit("modal:close");
			this.$bus.$emit("page:content:load");
			this.$inertia.reload({ preserveState: true, preserveScroll: true });
		},
		onError(error) {

			switch (error.response.status) {
				case 422:
					const errors = error.response.data.errors;
					this.$bus.$emit("form:invalid", errors);
					break;

				default:
					this.$bus.$emit("modal:error", error);
					break;
			}

		},
		emitDeleteModal(id) {
			this.$bus.$emit("modal:close");

			this.$bus.$emit('modal:open', {
				view: {
					view: 'views/Settings/UserLocationDelete',
					data: { id: id }
				},
				size: 'sm'
			})
		}
	},
	watch: {
		userLocations: {
			handler(val) {
				console.log(val)
			},
			deep: true
		}
	}
};
</script>
